import { MediaMatcher } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { OnInit, Renderer2, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry, } from '@app/router';
import { UiPersistentNotificationComponent } from '@components';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService, StorageService, } from '@services';
import { isInternetExplorer } from '@uipath/angular/utilities';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { combineLatest, from, fromEvent, merge, } from 'rxjs';
import { filter, map, startWith, switchMap, } from 'rxjs/operators';
import * as i0 from "@angular/core";
var AppRippleOptions = /** @class */ (function () {
    function AppRippleOptions() {
        this.disabled = false;
    }
    AppRippleOptions.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppRippleOptions_Factory() { return new AppRippleOptions(); }, token: AppRippleOptions, providedIn: "root" });
    return AppRippleOptions;
}());
export { AppRippleOptions };
var MainComponent = /** @class */ (function () {
    function MainComponent(_analytics, _translateService, _overlayContainer, _renderer, _appRippleOptions, _title, _appState, _router, _swUpdate, storageService, mediaMatcher, pageRegistry) {
        var _this = this;
        this._analytics = _analytics;
        this._translateService = _translateService;
        this._overlayContainer = _overlayContainer;
        this._renderer = _renderer;
        this._appRippleOptions = _appRippleOptions;
        this._title = _title;
        this._appState = _appState;
        this._router = _router;
        this._swUpdate = _swUpdate;
        this.animationsDisabled = false;
        this._onPrefersReducedMotionChanged = function (prefersReducedMotion) {
            _this.animationsDisabled = prefersReducedMotion;
            _this._renderer.setProperty(_this._overlayContainer.getContainerElement(), '@.disabled', _this.animationsDisabled);
            _this._appRippleOptions.disabled = prefersReducedMotion || !!isInternetExplorer();
        };
        this.languageClass = this._translateService.currentLang;
        var mediaReducedMotion = mediaMatcher.matchMedia('(prefers-reduced-motion: reduce)');
        _appRippleOptions.disabled = mediaReducedMotion.matches || !!isInternetExplorer();
        this._onPrefersReducedMotionChanged(mediaReducedMotion.matches);
        merge(fromEvent(mediaReducedMotion, 'change')
            .pipe(map(function (e) { return e.matches; })), storageService.watch('prefers-reduced-motion')
            .pipe(filter(function (event) { return event.newValue !== 'null'; }), map(function (event) { return Boolean(event.newValue); })), fromEvent(document.body, 'prefersReducedMotion')
            .pipe(map(function (event) { return event.detail; }))).subscribe(this._onPrefersReducedMotionChanged);
        this._router.events
            .pipe(filter(function (e) { return e instanceof NavigationEnd; }), map(function () { return _this._router.routerState.snapshot.root.queryParamMap.get('lang'); }), filter(function (languageCode) { return !!languageCode; }), switchMap(function (languageCode) { return _appState.language.set(languageCode); })).subscribe();
        combineLatest([
            this._translateService
                .onLangChange
                .pipe(startWith(void 0)),
            pageRegistry
                .activePage$.pipe(filterNullOrUndefined()),
        ])
            .subscribe(function (_a) {
            var _ = _a[0], page = _a[1];
            return _this._setDocumentTitle(page);
        });
    }
    Object.defineProperty(MainComponent.prototype, "isInternetExplorer", {
        get: function () {
            return isInternetExplorer();
        },
        enumerable: true,
        configurable: true
    });
    MainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._analytics.track('Application Load', { page: 'N/A' });
        this._swUpdate.available
            .pipe(switchMap(function () {
            _this._persistentNotification.show = true;
            return _this._persistentNotification.closed.pipe(filter(function (close) { return close === 'confirm'; }));
        }), switchMap(function () {
            return from(_this._swUpdate.activateUpdate());
        }))
            .subscribe(function () {
            return location.reload();
        });
    };
    MainComponent.prototype._setDocumentTitle = function (page) {
        var documentTitle = [
            !!page.translationKey
                ? this._translateService.instant(page.translationKey)
                : page.title,
            this._appState.authConfig.value.serverSettings.baseTitle,
        ].join(' - ');
        this._title.setTitle(documentTitle);
    };
    return MainComponent;
}());
export { MainComponent };
